import { Box, Container, HStack, VStack, Divider, Link, Text, Image } from "@chakra-ui/react";
import { FaFacebook, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";
import eduviclogo from "../../../resources/Eduvictechlogo.png";


const PublicFooter = () => {
  return (
    <Box bg="gray.700" color="white" py={8}>
      <Container maxW="1200px" px={4}>
        <HStack spacing={6} align="start" justify="space-between">
          {/* Logo Section */}
          <VStack align="start" spacing={3} flexBasis="30%">
            <Link href="/coaching">
            <Image src={eduviclogo} alt="Eduvic Logo" maxH="120px" objectFit="contain" />
            </Link>
          </VStack>
          
          <Divider orientation="vertical" height="200px" borderColor="gray.500" />

          {/* Important Links Section */}
          <VStack align="start" spacing={3} flexBasis="30%">
            <Text fontWeight="bold">Important Links</Text>
            <Link href="/practice#categories-section">Practice Tests</Link>
            <Link href="/practice/free-resources">Explore Free Resources</Link>
            <Link href="/practice/blog">Blogs</Link>
            <Link href="/practice/contact">Contact Us</Link>

          </VStack>

          <Divider orientation="vertical" height="200px" borderColor="gray.500" />

          {/* Social Media Section */}
          <VStack align="start" spacing={3} flexBasis="30%">
            <Text fontWeight="bold">Connect with Eduvic</Text>
           
            <HStack spacing={2}>
                <Link href="https://www.facebook.com/profile.php?id=61571594075413" isExternal>
                  <FaFacebook size="24px" />
                </Link>
                <Link href="https://www.facebook.com/profile.php?id=61571594075413" isExternal>
                 Facebook
                </Link>
                
              </HStack>
              
              <HStack spacing={2}>
                <Link href="https://www.instagram.com/eduviccomau/F" isExternal>
                  <FaInstagram size="24px" />
                </Link>
                <Link href="https://www.instagram.com/eduviccomau/" isExternal>
                Instagram
                </Link>
               
              </HStack>
              
              <HStack spacing={2}>
                <Link href="https://www.youtube.com/channel/UCATzCvYATjtZoK30_lX_rPA" isExternal>
                  <FaYoutube size="24px" />
                </Link>
                <Link href="https://www.youtube.com/channel/UCATzCvYATjtZoK30_lX_rPA" isExternal>
                YouTube
                </Link>
             
              </HStack>
              
              <HStack spacing={2}>
                <Link href="https://x.com/eduviccomau" isExternal>
                  <FaTwitter size="24px" />
                </Link>
                <Link href="https://x.com/eduviccomau" isExternal>
                  X
                </Link>
              </HStack>
            
          </VStack>
        </HStack>

        {/* Terms and Conditions and Copyright */}
        <Divider my={6} borderColor="gray.500" />
        <VStack spacing={3} align="center">
          <Link href="/practice/terms" color="gray.400">
            Terms and Conditions
          </Link>
          <Text fontSize="sm" color="gray.500">
           Eduvic Practice Platform | © 2025 Eduvic Technologies
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default PublicFooter;
